export enum EStavHl {
    NEHLASOVANO = 'NEHLASOVANO',
    HLASOVANO = 'HLASOVANO',
    ROZP = 'ROZP',
    LHUTA = 'LHUTA'
}
